<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-calculator'"></top-line>
    <el-row class="filter-bar">
      <el-card shadow="never">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
          <el-row>
            <el-col :span="20">
              <el-form-item label="算力名称：" prop="title" class="search-item" :label-width="labelWidth">
                <el-input v-model="searchForm.title" style="width:175px" />
              </el-form-item>
              <!-- <el-form-item label="算力类型：" prop="compute_type_name" class="search-item" :label-width="labelWidth">
                <el-input v-model="searchForm.compute_type_name" style="width:175px" />
              </el-form-item> -->
            </el-col>
            <el-col :span="4">
              <div class="action-buttons-right">
                <el-button type="success" icon="el-icon-plus" size="small" plain
                  @click="handleCreate">
                  新增
                </el-button>
                <el-button type="primary" icon="el-icon-search" size="small" plain
                  @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain
                  @click="handleReset">
                  重置
                </el-button>
              </div>
            </el-col>

          </el-row>
        </el-form>
      </el-card>
    </el-row>

    <el-row class="main-table">
      <el-card>
        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column prop="id" label="ID" width="180">
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="名称" width="180">
            <template slot-scope="scope">
              {{ scope.row.title }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="compute_type_name" label="算力类型" width="180">
            <template slot-scope="scope">
              {{ scope.row.compute_type_name }}
            </template>
          </el-table-column> -->
          <el-table-column prop="cpu" label="CPU" width="180">
            <template slot-scope="scope">
              {{ scope.row.cpu }}
            </template>
          </el-table-column>
          <el-table-column prop="memory_gb" label="内存(GB)" width="120">
            <template slot-scope="scope">
              {{ scope.row.memory_gb }}
            </template>
          </el-table-column>
          <el-table-column prop="gpu" label="GPU" width="180">
            <template slot-scope="scope">
              {{ scope.row.gpu }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格" width="180">
            <template slot-scope="scope">
              {{ scope.row.price }}
            </template>
          </el-table-column>
          <el-table-column prop="is_published" label="是否发布" width="140">
            <template slot-scope="scope">
              {{ scope.row.is_published === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="180">
            <template slot-scope="scope">
              {{ formatTime(scope.row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="同步时间" width="180">
            <template slot-scope="scope">
              {{ formatTime(scope.row.ext_03) }}
            </template>
          </el-table-column>
          
          <el-table-column prop="updated_at" label="更新时间" width="180">
            <template slot-scope="scope">
              {{ formatTime(scope.row.updated_at) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="240" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="showDetails(scope.row)">详情</el-button>
              <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click="handleSync(scope.row)">规格同步</el-button>
              <el-button type="text" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-size="pageSize"
            :current-page="currentPage"
            :page-sizes="pageSizeList"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
    </el-row>

    <!-- 新增算力规格 -->
    <create-compute-product
      ref="createComputeProduct"
      @success="getList"
    />

    <!-- 编辑算力规格 -->
    <edit-compute-product
      ref="editComputeProduct"
      @success="getList"
    />
  </d2-container>
</template>

<script>
import CreateComputeProduct from './CreateComputeProduct.vue'
import EditComputeProduct from './EditComputeProduct.vue'
import topLine from "@/components/save-common/topLine.vue";
import { formatTime } from "@/libs/system/time.js";

export default {
  components: {
    topLine,
    CreateComputeProduct,
    EditComputeProduct
  },
  data() {
    return {
      pageTitle: "算力规格管理",
      labelWidth: '120px',
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageSizeList: [10, 20, 50, 100],
      searchForm: {
        title: '',
        compute_type_name: '',
        page: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    formatTime,
    getList() {
      this.$axios.get('/api-30216/api/compute-products', {
        params: {
          title: this.searchForm.title,
          compute_type_name: this.searchForm.compute_type_name,
          page: this.currentPage,
          pageSize: this.pageSize
        }
      }).then(response => {
        if (response.code === 200) {
          this.tableData = response.data || [];
          this.total = response.total || 0;
        }
      }).catch(error => {
        this.$message.error('获取数据失败')
        console.log(error)
      })
    },
    handleCreate() {
      this.$refs.createComputeProduct.openDialog()
    },
    // 详情
    showDetails(row) {
      this.$router.push({
        path: '/computeProductDetails',
        query: {
          id: row.id,
          page: this.currentPage,       // 当前页码
          pageSize: this.pageSize, // 页面大小
        }
      })
    },
    handleEdit(row) {
      this.$refs.editComputeProduct.openDialog(row)
    },
    handleSync(row) {
      this.$axios.get(`/api-30216/api/compute-products/sync-to-portal/${row.id}`).then(response => {
        if (response.code === 200) {
          this.$message.success('同步成功')
          this.getList()
        } else {
          this.$message.error(response.message || '同步失败')
        }
      }).catch(error => {
        this.$message.error('同步失败')
        console.log(error)
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除这条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete(`/api-30216/api/compute-products/${id}`).then(response => {
          if (response.code === 200) {
            this.$message.success('删除成功')
            this.getList()
          }
        }).catch(error => {
          this.$message.error('删除失败')
          console.log(error)
        })
      })
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.currentPage = current
      this.getList()
    },
    handleSearch() {
      this.currentPage = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        title: '',
        compute_type_name: '',
        page: 1,
        pageSize: 10
      }
      this.getList()
    }
  }
}
</script>

<style scoped>
.filter-bar {
  margin-bottom: 10px;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.main-table {
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 20px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.dialog-footer {
  text-align: right;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}

.batch-button {
  min-width: 95px;
}

.action-buttons-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}

.action-buttons-right .el-button {
  margin-left: 0 !important;
}
</style>